import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
    <React.Fragment>
        <path d="m7.8 5.7h7.2c0.4 1.4 1.7 2.5 3.3 2.5 1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5c-1.7 0-3.1 1.2-3.4 2.8h-7c-2.8 0-5 2-5 4.6 0 2.5 2.2 4.5 5 4.5h7.7c1.8 0 3.3 1.1 3.3 2.8s-1.7 2.7-3.3 2.7h-6.4c-0.3-1.6-1.7-2.8-3.4-2.8-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5c1.6 0 2.9-1.1 3.3-2.5h6.4c3 0 5-1.9 5-4.3 0-2.6-2.2-4.4-5-4.4h-7.7c-1.9 0-3.3-1.2-3.3-2.8 0-1.9 1.5-3.1 3.3-3.1zm10.5-3.1c1.2 0 2.1 0.9 2.1 2.1s-0.9 2.1-2.1 2.1-2.1-0.9-2.1-2.1 0.9-2.1 2.1-2.1zm-12.5 18.6c-1.2 0-2.1-0.9-2.1-2.1s0.9-2.1 2.1-2.1 2.1 0.9 2.1 2.1-1 2.1-2.1 2.1z" />
    </React.Fragment>
);
